'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const dateformat=require('dateformat');
const TickIncrementCalculator=require('../../../../dist-es6/client/directives/plotting/tickIncrementCalculator');let

RouteGraphDirective=class RouteGraphDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/routeGraphDirective/routeGraphTemplate'}
get objectBindings(){return['scenarioBounds','schedule','route','fatigueThreshold','overallTrip']}
get controller(){return RouteGraphDirectiveController}};let


RouteGraphDirectiveController=class RouteGraphDirectiveController{
constructor(){
this.elementBindings={};
this._tickIncrementCalculator=new TickIncrementCalculator(TickIncrementCalculator.DefaultScales.slice(3));
}

topmostTextTickProvider(axis){
let idealTicks=this.dimensions.width/(8*60);
let tickIncrements=this._tickIncrementCalculator.calculate(axis.domain.duration,idealTicks);
return{
type:'d3Calculated',
interval:tickIncrements.minor.interval,
step:tickIncrements.minor.step};

}

topmostTextTickFormatter(date){
return dateformat(date,'ddd, mmm d');
}

hosTextTickProvider(axis){
return{
type:'values',
values:[3,2,1,0]};

}

hosTextTickFormatter(value){
switch(value){
case 0:
return'Off Duty';
case 1:
return'Sleeper';
case 2:
return'Driving';
case 3:
return'On Duty';}

}};


module.exports=RouteGraphDirective;
//# sourceMappingURL=routeGraphDirective.js.map
